import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
let PiBlankPage = class PiBlankPage extends Vue {
    created() {
        this.$router.go(-1); //返回上一层   这个页面是为了起到给当前路由刷新的效果，进来这再返回当前页面
    }
};
PiBlankPage = __decorate([
    Component({
        components: {},
    })
], PiBlankPage);
export default PiBlankPage;
